<eze-registration-closed
	formName="Owner"
	[url]="eventUrl"
	*ngIf="isClosed"
></eze-registration-closed>

<eze-smart-form-container *ngIf="!isClosed">
	<div header>
		<h1>Submit Competitor Protest</h1>
	</div>
	<div body>
		<div
			[innerHtml]="successHtml"
			*ngIf="successHtml"
			style="margin: 20px"
		></div>

		<div *ngIf="!successHtml">
			<fieldset>
				<eze-alert></eze-alert>
				<h3>Price: {{ price | currency }}</h3>
				<br />
			</fieldset>
		</div>
	</div>
	<div footer>
		<div class="buttons">
			<div style="margin-top: 10px; text-align: right">
				<eze-paypal-button
					*ngIf="!successHtml"
					[payload]="payload"
					[eventId]="eventId"
					entity="protests"
					(success)="onSuccess($event)"
					(error)="onError($event)"
				></eze-paypal-button>
			</div>

			<eze-button (click)="useStripe()" *ngIf="!successHtml">
				Pay With Card
			</eze-button>
		</div>

		<eze-button (click)="resetForm()" *ngIf="successHtml">
			Submit Another Protest
		</eze-button>
	</div>
</eze-smart-form-container>

<!-- <pre>{{ form.value | json }}</pre> -->
<!-- <pre>paylod = {{ payload | json }}</pre> -->

<eze-stripe-payment-modal
	#payByStripeModal
	[payload]="payload"
	[price]="price"
	entity="protests"
	(success)="onSuccess($event)"
	[eventId]="eventId"
	[stripeId]="stripePublicKey"
></eze-stripe-payment-modal>
